<template>
  <div class="timeline">
    {{ longDate }} | {{ price }}<template v-if="ageRestriction">
      | {{ ageRestriction }}</template
    >
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    event: Object,
    selectedDate: Object
  },
  computed: {
    longDate() {
      if (this.selectedDate)
        return (
          moment(this.selectedDate.startDate).format("dddd, MMMM Do YYYY") +
          " | " +
          moment(this.event.start.toDate()).format("h:mma") +
          " - " +
          moment(this.event.end.toDate()).format("h:mma")
        );
      if (!this.event.start || !this.event.end) return "";
      // if the end date is the next day but not more than 12 hours later, it is the same day for display purposes
      if (
        moment(this.event.start.toDate()).isSame(
          moment(this.event.end.toDate()),
          "date"
        ) ||
        (moment(this.event.end.toDate()).diff(
          moment(this.event.start.toDate()),
          "hours"
        ) < 12 &&
          moment(this.event.end.toDate()).diff(
            moment(this.event.start.toDate()),
            "days"
          ) < 1)
      )
        return (
          moment(this.event.start.toDate()).format("dddd, MMMM Do YYYY") +
          " | " +
          moment(this.event.start.toDate()).format("h:mma") +
          " - " +
          moment(this.event.end.toDate()).format("h:mma")
        );
      else
        return (
          moment(this.event.start.toDate()).format("MMMM Do") +
          " - " +
          moment(this.event.end.toDate()).format("MMMM Do YYYY")
        );
    },
    price() {
      if (this.event.minPrice == this.event.maxPrice) {
        if (this.event.minPrice == 0) return "FREE";
        else return "$" + this.event.minPrice;
      } else
        return (
          "$" +
          (this.event.minPrice == 0 ? "FREE" : this.event.minPrice) +
          "-" +
          this.event.maxPrice
        );
    },
    // The stored value is the display string itself. Absent or empty means the
    // organizer stated no policy, and nothing is rendered — not even the
    // separator. "All Ages" is a statement, so it does show.
    ageRestriction() {
      return this.event.ageRestriction
        ? this.event.ageRestriction.trim()
        : "";
    }
  }
};
</script>

<style></style>
